import React, { useState } from "react";
import BlogCard from "../mini/BlogCard";
import { useHistory } from "react-router-dom";
import Loader from "../mini/Loader";
import { useQuery } from "@tanstack/react-query";
import { getBlogsAPI_v2 } from "../../api/GetBlogs";
import * as H from "./Home.styled";

const PopularBlogs = () => {
  const history = useHistory();

  const [popularBlogs, setPopularBlogs] = useState([]);

  const { isLoading } = useQuery({
    queryKey: ["GetPopularBlogs"],
    queryFn: () =>
      getBlogsAPI_v2({
        size: 3,
        page: 1,
        category: "popular",
      }),
    select: ({ data }) => data.data.blogs,
    onSuccess: (blogs) => setPopularBlogs(blogs),
  });

  const handleViewAllBlogs = () => {
    history.push("/search/1/blogs");
  };

  return (
    <>
      {isLoading ? (
        <Loader />
      ) : (
        popularBlogs.length > 0 && (
          <H.HomeSidebarWrapper>
            <H.HomeTitle>Popular Blogs</H.HomeTitle>
            {popularBlogs.map((blog) => (
              <div key={blog.id}>
                <BlogCard blog={blog} />
                <hr className="line mt-4 mb-2" />
              </div>
            ))}

            <H.ViewAll onClick={handleViewAllBlogs}>View All</H.ViewAll>
          </H.HomeSidebarWrapper>
        )
      )}
    </>
  );
};

export default PopularBlogs;
